import { combineReducers } from 'redux'
import { createSelector } from '@reduxjs/toolkit'
import { IAppState } from '../../../common/context/context'
import filtrosReducer, {
  initialState as filtrosInitialState,
  SearchNeumaticosFiltrosMotoStateType,
} from './filtrosMoto.slice'
import medidasReducer, {
  initialState as medidasInitialState,
  SearchNeumaticosMedidasMotoStateType,
  OrderedMedidasMoto,
} from './medidasMoto.slice'

export const version = 1
export const key = 'searchNeumaticosMoto'

export interface SearchNeumaticosMotoStateType {
  _version: number
  medidas: SearchNeumaticosMedidasMotoStateType
  filtros: SearchNeumaticosFiltrosMotoStateType
}

export const initialState: SearchNeumaticosMotoStateType = {
  _version: version,
  medidas: medidasInitialState,
  filtros: filtrosInitialState,
}

const searchNeumaticosMotoVersionReducer = (
  state: number = version,
  _action: unknown
): number => state

export const searchNeumaticosMotoReducer = combineReducers({
  _version: searchNeumaticosMotoVersionReducer,
  medidas: medidasReducer,
  filtros: filtrosReducer,
})

export default searchNeumaticosMotoReducer

export const selectSearchNeumaticosMoto = (
  state: IAppState
): SearchNeumaticosMotoStateType => (state as IAppState).searchNeumaticosMoto

export type SearchNeumaticosMotoQueryState = {
  medidas: {
    selectedMedidas: SearchNeumaticosMotoStateType['medidas']['selectedMedidas']
  }
}

export const selectSearchNeumaticosMotoQueryState = createSelector(
  [selectSearchNeumaticosMoto],
  (s): SearchNeumaticosMotoQueryState => ({
    medidas: {
      selectedMedidas: s.medidas.selectedMedidas,
    },
  })
)

export type NeumaticosMotoBaseFilterValues = {
  permiso_comercial?: number
  device?: string
  zipcode?: string | null
  email?: string | null
  phone?: string | null
  origen?: string
  useragent?: string
  ancho?: number
  alto?: number
  llanta?: number
}

export const mapSearchNeumaticosMotoToQuery = (
  searchState: SearchNeumaticosMotoStateType,
  options: {
    device: 'MOBILE' | 'TABLET' | 'DESKTOP'
    email?: string | null
    phone?: string | null
    zipcode?: string | null
    permisoComercial?: number | null
  }
): NeumaticosMotoBaseFilterValues => {
  const { device, email, phone, zipcode, permisoComercial } = options
  const { selectedMedidas } = searchState.medidas

  const filters: NeumaticosMotoBaseFilterValues = {
    permiso_comercial: permisoComercial || 0,
    device,
    email,
    phone,
    zipcode,
    origen: '/',
    useragent: navigator.userAgent,
  }

  const toNumber = (v: string | number | null | undefined) =>
    v == null || v === '' ? undefined : Number(v)

  filters.ancho = toNumber(selectedMedidas.ancho)
  filters.alto = toNumber(selectedMedidas.alto)
  filters.llanta = toNumber(selectedMedidas.llanta)

  return filters
}

export const buildMotoMeasuresSubtitle = (
  selectedMedidas: SearchNeumaticosMedidasMotoStateType['selectedMedidas']
) => {
  const ancho = selectedMedidas.ancho
  const alto = selectedMedidas.alto
  const llanta = selectedMedidas.llanta

  if (ancho == null || alto == null || llanta == null) return ''
  return `${ancho}/${alto} ${llanta}`
}

export const isMeasuresCompleteMoto = (
  selectedMedidas: SearchNeumaticosMedidasMotoStateType['selectedMedidas']
) => OrderedMedidasMoto.every((k) => selectedMedidas[k] != null)

// (imported above)
